export default function (instance) {
  return {
    get(credentialId, config = {}) {
      return instance.get(`credentials/${credentialId}`, config);
    },
  };
}
